import { gql } from "@apollo/client";

const OMNISEARCH_QUERY = gql`
  query omnisearch($queryString: String!, $limit: Int) {
    omnisearch(queryString: $queryString, limit: $limit) {
      name
      metadataDisplay
      resourceType
      urlResourceId
      relevanceScore
    }
  }
`;

export { OMNISEARCH_QUERY };
